// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: util/common/lcmtypes/flight_phase_transition_t.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  INVALID = 0,
  NOMINAL = 1,
  USER_REQUESTED = 2,
  FAULT = 3,
  DISARMED = 4,
  MANUAL_MODE = 5,
  DOCK_INSPECTION_MODE = 6,
  PILOT_STATUS_SHOULD_REST = 7,
  PERCH_PENDING = 8,
}

export class flight_phase_transition_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (flight_phase_transition_t._packed_fingerprint === undefined) {
      flight_phase_transition_t._packed_fingerprint = flight_phase_transition_t._get_hash_recursive([]);
    }
    return flight_phase_transition_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(flight_phase_transition_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = flight_phase_transition_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): flight_phase_transition_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(flight_phase_transition_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, flight_phase_transition_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): flight_phase_transition_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get INVALID() {
    return new flight_phase_transition_t(option_t.INVALID);
  }
  static get NOMINAL() {
    return new flight_phase_transition_t(option_t.NOMINAL);
  }
  static get USER_REQUESTED() {
    return new flight_phase_transition_t(option_t.USER_REQUESTED);
  }
  static get FAULT() {
    return new flight_phase_transition_t(option_t.FAULT);
  }
  static get DISARMED() {
    return new flight_phase_transition_t(option_t.DISARMED);
  }
  static get MANUAL_MODE() {
    return new flight_phase_transition_t(option_t.MANUAL_MODE);
  }
  static get DOCK_INSPECTION_MODE() {
    return new flight_phase_transition_t(option_t.DOCK_INSPECTION_MODE);
  }
  static get PILOT_STATUS_SHOULD_REST() {
    return new flight_phase_transition_t(option_t.PILOT_STATUS_SHOULD_REST);
  }
  static get PERCH_PENDING() {
    return new flight_phase_transition_t(option_t.PERCH_PENDING);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.INVALID;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}